import { 
    FETCH_MATCH_DATA, 
    CREATE_LIVE_FOR_MATCH, 
    CANCEL_LIVE, SUBSCRIBE, 
    UPDATE_LIVE_ON_MATCH_DATA, 
    DELETE_LIVE_ON_MATCH_DATA, 
    WORKER_CANCEL_LIVE_ON_MATCH_DATA, 
    UNSUBSCRIBE_LIVE 
} from '../constants';
import axios from 'axios';
import { API_HOST } from '../config.env';
import {me, userExist} from '../helpers';
import _ from 'lodash';
import moment from 'moment';

const headers = access => {
    return {
        headers: {
            Accept: 'application/ld+json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access}`
        }
    }
}

export const fetchMatchData = access => {
    return dispatch => {
        const caches = localStorage.getItem('matchData');
        if(caches && !_.isEmpty(JSON.parse(caches).upcoming) && (moment().unix() - JSON.parse(caches).cache_ttl_expires_at) < 0) {
            const promise = new Promise((resolve, reject) => {
                resolve();
            })
            return promise.then(() => dispatch({type: FETCH_MATCH_DATA, payload: JSON.parse(caches)}))
        }
        else {
            if(userExist()) {
                return axios.get(`${API_HOST}/api/users/${me().id}/matches`, headers(access))
                .then(response => {
                    if(response.status === 200) {
                        const match = response.data['hydra:member'][0];
                        _.assign(match, {cache_ttl_expires_at: moment().add(1, 'days').unix()})
                        dispatch({type: FETCH_MATCH_DATA, payload: match});
                        localStorage.setItem('matchData', JSON.stringify(match));
                    }
                })
                .catch(() => dispatch({type: FETCH_MATCH_DATA, payload: {upcoming: {}, past: {}} }))
            }
            else {
                const promise = new Promise((resolve, reject) => {
                    resolve();
                })
                return promise.then(() => dispatch({type: FETCH_MATCH_DATA, payload: {upcoming: {}, past: {}} }));
            }
        }
    }
}

export const createLiveForMatch = (live, maNo) => ({type: CREATE_LIVE_FOR_MATCH, payload: {live, maNo}});

export const cancelLive = (live, maNo) => ({type: CANCEL_LIVE, payload: {live, maNo}});

export const subscribeLive = (live) => ({type: SUBSCRIBE, payload: {live}});

export const updateActionLive = (id, actions) => ({type: UPDATE_LIVE_ON_MATCH_DATA, payload: {id, actions}});

export const deleteActionLive = (id, action) => ({type: DELETE_LIVE_ON_MATCH_DATA, payload: {id, action}});

export const cancelLiveFromWorker = id => ({type: WORKER_CANCEL_LIVE_ON_MATCH_DATA, payload: {id}});

export const unsubscribeLive = (id, unsubscriber) => ({type: UNSUBSCRIBE_LIVE, payload: {id,unsubscriber}});
